<div [formGroup]="formCustomFields" class="container">
  <div class="row">
    @for (field of filterFields; track $index; let key = $index) {
      <article [id]="'article-'+field.id" [hidden]="field.hidden || (haveConfigShowFields && !edit && !field.showincreate)"
        [ngClass]="field.type === 48 || field.type === 49 || field.type === 35 || field.type === 22 || field.type === 7 || field.type === 54 || (field.type === 20 && !shouldHideContractSubtypeField(field)) ? 'col-md-12' : 'col-md-6'"
        >
        @if (field.type === 49) {
          <div class="section-header">
            <span class="section-title">
              <i class="fas fa-table section-icon"></i>
              {{ field.alias?field.alias:field.name }}
            </span>
          </div>
        }
        @if (field.type === 35) {
          <div class="section-divider"></div>
        }
        @if (field.type === 48; as blockElse) {
          <div class="card type-48-group">
            <div class="card-header pl-0 pr-0">
              <h4 class="card-title"><i class="fa fa-object-group ml-1"></i> {{ field.alias }}</h4>
              @if (!isSingleRepeat(field)) {
              <div class="heading-elements">
                <ul class="list-inline mb-0">
                  <li>
                    <button class="btn btn-outline-primary box-shadow text-dark"
                      [ngbTooltip]="'Agregar'"
                      (click)="addRepeat($event.preventDefault(),field,field.id,true)">
                      <i class="fas fa-plus"></i>
                    </button>
                  </li>
                </ul>
              </div>
              }
            </div>
            <div class="card-content pl-0" [formArrayName]="field.id">
              @if (listSubGroup(field).length === 0) {
                <div class="empty-group-message">
                  <i class="fas fa-info-circle"></i>
                  <span>{{ emptyRepeatText(field) }}</span>
                </div>
              }
              @for (repeatForm of listSubGroup(field); track $index; let i = $index) {
                <div class="card-body pb-0 sub-group"
                  >
                  @if (!isSingleRepeat(field)) {
                  <div class="row mb-2">
                    <h6
                      class="d-flex justify-content-start align-items-center col-md-10 card-subtitle text-muted">
                    {{ repeatHeading(field, i) }}</h6>
                    <div class="col-md-2  d-flex justify-content-end align-items-center">
                      <ul class="list-inline mb-0">
                        <li>
                          <a type="button" class="danger" [ngbTooltip]="'Eliminar'"
                            (click)="removeRepeat(field,i)">
                            <i class="fas fa-times-circle mr-0"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  }
                  <div class="row" [formGroupName]="i">
                    @for (item of field.customfields; track $index) {
                      @if (item && !isCopySourceIndexField(field, item)) {
                      <article [ngClass]="{'col-md-6': item.type!=7 && !hasCopyFromGroup(item) && !layoutSpansFull(item),'col-md-12': item.type==7 || hasCopyFromGroup(item) || layoutSpansFull(item),'field-span-12': layoutSpansFull(item)}" [hidden]="isType48ChildHidden(field.id, i, item)" [attr.data-type48-id]="field.id" [attr.data-row-index]="i" [attr.data-field-id]="item.id">
                        <app-custom-fields-switch [formCustomFields]="repeatForm" [field]="item" [type48RowIndex]="i"
                          [type16RowStoredValue]="item.type === 16 ? type48SubfieldStoredValue(field, i, item) : null"
                          [hideHitesContractSubtype]="hideHitesContractSubtype"
                          [copySourceOptions]="copySourceOptionsFor(item)"
                          [copyAllowOther]="copyAllowsOther(item)"
                          [copyOtherLabel]="copyOtherLabel(item)"
                          [copyOtherValue]="copyOtherValue(item)"
                          [copyIndexFieldId]="copyIndexFieldIdFor(field, item)"
                          [copyLocksActive]="rowCopyLocksActive(field, i)"
                          [type14RefreshToken]="item._type14RefreshToken || null"
                          [fieldIsNotEmpty]="fieldIsNotEmpty"
                          [options1]="options1" [isEditing]="isEditing" [nestedValues]="nestedValues"
                          [counterTree]="counterTree" [setSelectValue]="setSelectValue" [edit]="edit"
                          (onChangeChild)="onChange($event, field.id, i)"
                          (formatearRutChild)="formatearRut($event)"
                          (rutKeyupChild)="rutKeyup($event)"
                          (onCheckboxChangeChild)="onCheckboxChange($event)"
                          (onCheckRadioChangeChild)="onCheckRadioChange($event)"
                          (removeInputChild)="removeInput($event)" (addInputChild)="addInput($event)"
                          (addDataChild)="addData($event)"
                          (onValueChangeChild)="onValueChange($event)"
                          (removeDataChild)="removeData($event)"
                          (deleteItemChild)="deleteItem($event)"
                          (compareSelectSimpleWithInputTextChild)="compareSelectSimpleWithInputText($event)"
                          (getItem24ValuesChild)="getItem24Values($event)"
                          (getItem22ValuesChild)="getItem22Values($event)"
                          (addInputToArrayChild)="addInputToArray($event)"
                          (onValueChange26Child)="onValueChange26($event)"
                          (removeItemRepeaterChild)="removeItemRepeater($event)"
                          (addItemRepeaterChild)="addItemRepeater($event)"
                          (findItemSelectChild)="findItemSelect($event)"
                          (onValueChange50Child)="onValueChange50($event)"
                          (addItemChild)="addItem($event)">
                        </app-custom-fields-switch>
                      </article>
                      }
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <app-custom-fields-switch #blockElse [formCustomFields]="formCustomFields" [field]="field"
          [hideHitesContractSubtype]="hideHitesContractSubtype"
          [subtype]="subtype" [isDisabledDateSla]="isDisabledDateSla" [fieldIsNotEmpty]="fieldIsNotEmpty"
          [options1]="options1" [isEditing]="isEditing" [nestedValues]="nestedValues"
          (onChangeChild)="onChange($event)" [counterTree]="counterTree" [setSelectValue]="setSelectValue"
          [edit]="edit" [flagActionLog]="flagActionLog" (parseSubTypeChild)="parseSubType($event)"
          (formatearRutChild)="formatearRut($event)" (rutKeyupChild)="rutKeyup($event)"
          (onCheckboxChangeChild)="onCheckboxChange($event)"
          (onCheckRadioChangeChild)="onCheckRadioChange($event)" (removeInputChild)="removeInput($event)"
          (addInputChild)="addInput($event)" (addDataChild)="addData($event)"
          (onValueChangeChild)="onValueChange($event)" (removeDataChild)="removeData($event)"
          (deleteItemChild)="deleteItem($event)"
          (compareSelectSimpleWithInputTextChild)="compareSelectSimpleWithInputText($event)"
          (getItem24ValuesChild)="getItem24Values($event)" (getItem22ValuesChild)="getItem22Values($event)"
          (addInputToArrayChild)="addInputToArray($event)" (onValueChange26Child)="onValueChange26($event)"
          (removeItemRepeaterChild)="removeItemRepeater($event)" (addItemRepeaterChild)="addItemRepeater($event)"
          (findItemSelectChild)="findItemSelect($event)" (onValueChange50Child)="onValueChange50($event)"
          (addItemChild)="addItem($event)">
        </app-custom-fields-switch>
      </article>
    }
  </div>
</div>
